<template>
	<div class="z-1000 w-9 gap-2 flex flex-col">
		<button
			@click="openSearchModal"
			class="flex items-center justify-center btn-default w-full p-1 aspect-square cursor-pointer"
			aria-label="Open search modal"
		>
			<img
				alt="search icon"
				src="/images/icons/search.svg"
				width="15"
				height="15"
			/>
		</button>

		<div class="">
			<button
				@click="onZoomIn"
				class="btn-default w-full rounded-b-none aspect-square flex items-center justify-center"
				:class="can_zoom_in ? 'cursor-pointer' : 'disabled cursor-not-allowed'"
				:disabled="!can_zoom_in"
				aria-label="Zoom in"
			>
				<img
					alt="search icon"
					src="/images/icons/plus-icon.svg"
					width="18"
					height="18"
					:class="can_zoom_in ? '' : 'opacity-50'"
				/>
			</button>
			<button
				@click="onZoomOut"
				class="btn-default w-full rounded-t-none aspect-square border-t border-neutral-200 border-opacity-20 flex items-center justify-center"
				:class="can_zoom_out ? 'cursor-pointer' : 'disabled cursor-not-allowed'"
				:disabled="!can_zoom_out"
				aria-label="Zoom out"
			>
				<img
					alt="search icon"
					src="/images/icons/minus-icon.svg"
					width="18"
					height="18"
					:class="can_zoom_out ? '' : 'opacity-50'"
				/>
			</button>
		</div>
	</div>
</template>
<script src="./Script.js"></script>
